import { queryOptions, useQuery } from '@tanstack/react-query'
import { QueryConfig } from '@/utils/reactQuery'
import apiClient from '@/utils/api'
import { Doc } from '@/features/docs/types/docsModel'

const getDocs = async (): Promise<Doc[]> => {
  const response = await apiClient.get<Doc[]>('/documents/get-all')
  return response.data
}

const getDocsOptions = () => {
  return queryOptions({
    queryKey: ['docs'],
    queryFn: () => getDocs(),
  })
}

type UseDocsProps = {
  queryConfig?: QueryConfig<typeof getDocsOptions>
}

const useDocs = ({ queryConfig }: UseDocsProps) => {
  return useQuery({
    ...getDocsOptions(),
    ...queryConfig,
  })
}

export { getDocs, getDocsOptions, useDocs }
